export default "__VITE_ASSET__BukBLDPn__";